import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import { columnesTaulaHistoricObservadors } from './configuracioTaulaHistoricObservadors';
import { convertirTextAMomentUTC, MASCARA_YYYYMMDD, MASCARA_DDMMYYYY } from '../../commons/gestioDates';

const mascaraMostrarDates = MASCARA_DDMMYYYY;

const renderitzarData = dataText => {
    if (dataText) {
        return convertirTextAMomentUTC(dataText, MASCARA_YYYYMMDD).format(mascaraMostrarDates);
    }
};

const crearColumnesPerTaula = (columnes) => {
    columnes.forEach((columna) => {
        if (columna.key === 'dataAlta') {
            columna.render = (text) => renderitzarData(text);
        }

        if (columna.key === 'dataBaixa') {
            columna.render = (text) => renderitzarData(text);
        }
    });

    return columnes;
};

const EstacioDetallHistoricObservadors = (props) => {
    const { historicObservadors } = props;

    const columnesDetallHistoricObservador = crearColumnesPerTaula(columnesTaulaHistoricObservadors());

    return (
        <Table
            rowKey={record => record.idEstacioUsuari}
            dataSource={historicObservadors}
            columns={columnesDetallHistoricObservador}
            size='small'
            bordered
            pagination={{pageSize: 4, hideOnSinglePage: true}}
        />
    );
};

EstacioDetallHistoricObservadors.propTypes = {
    historicObservadors: PropTypes.arrayOf(
        PropTypes.shape({
            idEstacioUsuari: PropTypes.number,
            idUsuari: PropTypes.number,
            nomComplet: PropTypes.string,
            codi: PropTypes.string,
            dataAlta: PropTypes.string,
            dataBaixa: PropTypes.string
        })
    )
};

export default EstacioDetallHistoricObservadors;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallHistoricObservadors.js